import * as angular from 'angular';

const componentOptions = {
    bindings: {
        infoToShowNewMap: '='
    },
    controllerAs: 'ibSeatMapInfoBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-seat-map-info-box-view.html';
    }]
};
const componentInfo = {
    module: 'ib-seat-map-info-box-module',
    selector: 'ibSeatMapInfoBox',
    inject: [],
    required: ['ib-web-ancillaries-module']
};


export class ibSeatMapInfoBox implements angular.IController {
    infoToShowNewMap: number;
    btnText: string;
    title: string;
    text: string;
    icon: string;

    constructor () {
    }


    $onInit (): void {
        this.getMessageForInfoBox();
    }

    getMessageForInfoBox (): void {
        this.setInfoText();

        setInterval(() => {
            this.setInfoText();
        }, 10000);

    }

    setInfoText (): void {
        this.infoToShowNewMap = Math.floor(Math.random() * 3);
        this.btnText = '{{\'SEAT_MAP_INFO_BTN_TEXT\'|translate}}';
        switch (this.infoToShowNewMap) {
                case 0:
                    this.icon = 'icon-asiento-plus';
                    this.title = '{{\'SEAT_MAP_INFO_SEAT_XL_TITLE\'|translate}}';
                    this.text =  '{{\'SEAT_MAP_INFO_SEAT_XL_TEXT\'|translate}}';
                    break;
                case 1:
                    this.icon = 'icon-asiento-delantero';
                    this.title =  '{{\'SEAT_MAP_INFO_FRONT_SEAT_TITLE\'|translate}}' ;
                    this.text = '{{\'SEAT_MAP_INFO_FRONT_SEAT_TEXT\'|translate}}';
                    break;
                case 2:
                    this.icon = 'icon-embarque-prioritario';
                    this.title =  '{{\'SEAT_MAP_INFO_PRIORITY_TITLE\'|translate}}';
                    this.text = '{{\'SEAT_MAP_INFO_PRIORITY_TEXT\'|translate}}';
                    break;
        }
    }


}
try {
    const mod = angular.module(componentInfo.module);
    ibSeatMapInfoBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSeatMapInfoBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibSeatMapInfoBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibSeatMapInfoBox })
    );
}
